<script lang="ts">
  import { AlertDialog, Dialog } from 'bits-ui';
  import { useCoordinatedModal } from '$lib/overlays/modal-coordinator.svelte';

  let {
    open = $bindable(false), modalPriority, variant = 'dialog',
    onOpenChange, onOpenChangeComplete, ...restProps
  }: Dialog.RootProps & { modalPriority?: number; variant?: 'dialog' | 'alert-dialog' } = $props();

  const modal = useCoordinatedModal(() => open, () => modalPriority);
  const Root = $derived(variant === 'alert-dialog' ? AlertDialog.Root : Dialog.Root);
</script>

<Root
  {...restProps}
  bind:open={() => modal.open, (value) => { open = value; }}
  {onOpenChange}
  onOpenChangeComplete={(value) => {
    // Suspension is presentation-only; it must not cancel the owning workflow.
    if (value === open) onOpenChangeComplete?.(value);
  }}
/>
